import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule, IconModule, StructuredListModule, TilesModule } from 'carbon-components-angular';
import { catchError, forkJoin, of, take } from 'rxjs';
import { MatDialogComponent } from 'src/app/mat-dialog/mat-dialog.component';
import { AppService } from 'src/app/services/app.service';
import { StyleSettingsDealerImage, StyleSettingsResponse, Client, StyleSettingTitles } from 'src/app/services/client.service';
import { DownloadPdfService } from 'src/app/services/download-pdf.service';
import { TourGuideDialogComponent } from 'src/app/tour-guide-dialog/tour-guide-dialog.component';
import { VvrJobsAuthComponent } from '../../vvr-jobs-auth/vvr-jobs-auth/vvr-jobs-auth.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { MatSnackBarComponent } from 'src/app/mat-snack-bar/mat-snack-bar.component';

@Component({
  selector: 'app-vvr-jobs',
  templateUrl: './vvr-jobs.component.html',
  styleUrls: ['./vvr-jobs.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    CommonModule,
    IconModule,
    ButtonModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    StructuredListModule,
    MatButtonModule,
    MatSnackBarModule,
    MatMenuModule,
    RouterModule,
    VvrJobsAuthComponent
  ],

})
export class VvrJobsComponent {
  readonly findingColors = { critical: 'Red', caution: 'Yellow' } as const;
  chooseLanguageText: string = $localize`Choose Language`;
  languageTranslationInfoText: string = $localize`Choose a language option to view page in your preferred language.`;
  pendingIssuesText: string = $localize`Vehicle findings`;
  PendingIssuesInfoText: string = $localize`Please review the identified issues.Pending requests require your authorization.`;
  checkedOkInfoText: string = $localize`Please review the Checked and Ok items`;
  downloadpdf: string = $localize`Download PDF`;
  downloadpdfDescription: string = $localize`Download the PDF report`;
  value: any = null;
  criticalCount = 0;
  cautionCount = 0;
  checkedOkCount = 0;
  needAuthorization = 0;
  pdfBase64Data: string = '';
  isPDFDataAvailable: boolean = true;
  token: string = '';
  isLargeScreen: boolean = window.innerWidth > 900;
  isScreenSize:boolean=window.innerWidth > 900;
  apiResponse: any;
  isDownloading = false;
  downloadCompleted = false;
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  siteSettings: StyleSettingsResponse | undefined;
  currentStepperPosition: number | undefined;
  @ViewChild('downloadPDFTour') downloadPDFTour!: ElementRef;
  @ViewChild('pendingIssues') pendingIssues!: ElementRef;
  @ViewChild('checkedOk') checkedOk!: ElementRef;
  totalSteps: number = 4;
  isAuthComponentCalls : boolean = false;
  isAllowed = true;  
  dealerImageDisplay: boolean = false;
  currentWindowWidth: number = window.innerWidth;

  constructor(public dialog: MatDialog, private readonly router: Router, private readonly route: ActivatedRoute, private readonly pdfService: DownloadPdfService, public appService: AppService, private readonly client: Client, @Inject(PLATFORM_ID) private platformId: Object,private snackBar: MatSnackBar,private featureFlagService: FeatureFlagService) { }

ngOnInit(): void {
  this.checkScreenSize();

  this.route.queryParams.subscribe(params => {
    this.token = params['token'];

    this.featureFlagService.getFeatures(this.token, 'VVR-Report')
      .then(allowed => {
        if (!allowed) {
          this.isAllowed = false;
          this.snackBar.openFromComponent(MatSnackBarComponent, {
            data: `The feature " Visual Vehicle Reception Report" is currently not enabled in MW Admin Portal - Feature Management. Please contact support for more information.`,
            duration: 10000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
          });
          return;
        }
        this.getChecklistReport(this.token);
        this.loadChecklistData();
      })
      .catch(() => {
        this.isAllowed = false;
      });
  });
}


  onChecklistUpdate(): void {
    if (this.isLargeScreen) {
      this.isAuthComponentCalls = true;
      this.loadChecklistData();
    }
  }

  openWelcomeDialog() {
    const localLang = localStorage.getItem('lang')
    if (localLang == null) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          type: 'LanguageDialog',
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        this.welcomeDialog(this.apiResponse.healthCheckReportDetails.order.customer.name);
      });
    } else {
      this.appService.setDefaultLanguage();
      this.welcomeDialog(this.apiResponse.healthCheckReportDetails.order.customer.name);
    }

    if(this.isScreenSize==false)
    {
    this.appService.tourGuideStepPosition$.subscribe((position: number) => {
      if (position !== undefined) {
        this.currentStepperPosition = position
      }
      if (position > 0) {
        let targetElementRect
        const dialogConfig = new MatDialogConfig()
        if (position === 1) {
          this.appService.languaTourGuide('vhc-jobs');
        } else if (position === 2) {
          targetElementRect = this.downloadPDFTour.nativeElement.getBoundingClientRect();
          this.downloadPDFTour.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: this.downloadpdf,
            desciption: this.downloadpdfDescription,
            stepCount: 2,
            totalSteps: this.totalSteps,
            position: targetElementRect
          }
          this.startVhcTour(dialogConfig);
        } else if (position === 3) {
          targetElementRect = this.pendingIssues.nativeElement.getBoundingClientRect();
          this.pendingIssues.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: "Pending Issues",
            desciption: "Click here to view the pending issues",
            stepCount: 3,
            totalSteps: this.totalSteps,
            position: targetElementRect
          };
          this.startVhcTour(dialogConfig);
        } else if (position === 4) {
          targetElementRect = this.checkedOk.nativeElement.getBoundingClientRect();
          this.checkedOk.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: "Checked OK",
            desciption: "Click here to view the checked OK",
            stepCount: 4,
            totalSteps: this.totalSteps,
            position: targetElementRect
          };
          this.startVhcTour(dialogConfig);
        }
      }
    });
  }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.currentWindowWidth = (event.target as Window).innerWidth;
    this.hideDealerImage();
  }

  loadChecklistData() {
    if (!this.token) {
      return;
    }

    this.appService.healthCheckReportWithJobs$ = undefined;
    this.appService.companySetting$ = undefined;
    this.appService.getDealerMediaResponse$ = undefined;

    forkJoin({
      healthCheckReport: this.appService.getHealthCheckReportWithJobs(this.token),
      stylesettings: this.appService.getStyleSettings(this.token).pipe(
        catchError(() => {
          return of(null);
        })
      ),
      dealermedia: this.appService.getDealerMediaResponse(this.token).pipe(
        catchError(() => {
          return of(null);
        })
      )
    })
      .pipe(take(1))
      .subscribe({
        next: ({ healthCheckReport, stylesettings, dealermedia }) => {
          this.apiResponse = healthCheckReport;
          this.siteSettings = stylesettings;
          this.dealerImageDetails = stylesettings?.dealerImage;
          this.hideDealerImage();
          this.calculateChecklistSummary();
          const tourGuide = sessionStorage.getItem('tourGuide');
          if(tourGuide !== 'true' && !this.isAuthComponentCalls)
          {
            this.openWelcomeDialog();
          }
          if (dealermedia) {
            this.appService.getDealerMediaResponse$ = dealermedia;
          }
        },
        error: (error) => {
          const errorMessage = error instanceof Error ? error.message : String(error);
          console.error("API call failed in vhc jobs component:", errorMessage);
          this.appService.handleErrorMessage(errorMessage);
        }
      });
  }

  private hideDealerImage(): void {
    if (this.dealerImageDetails) {
      this.dealerImageDisplay = !this.dealerImageDetails.url;
    } else {
      this.dealerImageDisplay = false;
    }
  }
  welcomeDialog(customerName: string | undefined) {
    const title = this.siteSettings?.titles?.find((title: StyleSettingTitles) => {
      return title.page === 'VhcReport' && title.type === 'Welcome' && title.content;
    });
    const Content = title?.content ? this.appService.convertToHtml(title.content) : null;
    if(this.isScreenSize==false){
    const dialogRef = this.dialog.open(MatDialogComponent, {
      data: {
        type: 'VHCReportWelcomeDialog',
        customerName: customerName,
        content: Content
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      sessionStorage.setItem("tourGuide", "true")
      if (result) {
        this.appService.tourGuideStepPosition(1)
      }
    });
  }else{
    const dialogRef = this.dialog.open(MatDialogComponent, {
      data: {
        type: 'VHCReportWelcomeDialogInLargeScreen',
        customerName: customerName,
        content: Content
      },
    });
  }

  }

  startVhcTour(dialogConfig: MatDialogConfig) {
    let screenInnerHeight;
    if (isPlatformBrowser(this.platformId)) {
      screenInnerHeight = window.innerHeight
    } else {
      screenInnerHeight = 0
    }
    if (screenInnerHeight > dialogConfig.data.position.bottom) {
      if (screenInnerHeight - dialogConfig.data.position.bottom > 200) {
        dialogConfig.position = {
          top: `${dialogConfig.data.position.bottom + 5}px`,
          left: `${dialogConfig.data.position.right - 270}px`,
        };
      }
      else {
        dialogConfig.position = {
          top: `${dialogConfig.data.position.bottom - 200}px`,
          left: `${dialogConfig.data.position.right - 270}px`,
        };
      }
    }
    else {
      window.scroll({
        top: dialogConfig.data.position.bottom,
        behavior: 'smooth'
      });
      dialogConfig.position = {
        top: `${(screenInnerHeight - dialogConfig.data.position.height) - 210}px`,
        left: `${dialogConfig.data.position.right - 270}px`,
      };
    }

    setTimeout(() => {
      const dialogRef = this.dialog.open(TourGuideDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        this.downloadPDFTour.nativeElement.classList.remove('tour-dialog-indication');
        this.pendingIssues.nativeElement.classList.remove('tour-dialog-indication');
        this.checkedOk.nativeElement.classList.remove('tour-dialog-indication');
        this.appService.tourGuideStepPosition(result)
      });
    }, 200);
  }

  calculateChecklistSummary(): void {
    this.criticalCount = 0;
    this.cautionCount = 0;
    this.checkedOkCount = 0;
    this.needAuthorization = 0;

    this.apiResponse?.healthCheckReportDetails?.categories.forEach(({ checkpoints }: any) => {
      checkpoints.forEach(this.processCheckpoint.bind(this));
    });
  }

  private processCheckpoint(checkpoint: any): void {

    checkpoint?.findings?.forEach((finding: any) => {
      const findingColor = checkpoint?.findingTypeOptions?.find(
        (option: any) => option?.id === finding?.findingType?.id
      )?.color || 'Unknown';

      if (findingColor === this.findingColors.critical) {
        this.criticalCount++;
      } else if (findingColor === this.findingColors.caution) {
        this.cautionCount++;
      }
      this.needAuthorization += this.countPendingAuthorization(finding?.serviceJobs || []);
    });

    if (checkpoint.status === 'NotOK' && (!(checkpoint?.findings?.length > 0) || checkpoint?.measuredValues?.length > 0)) {
      this.cautionCount++;
    }

    if (checkpoint.status === 'OK') {
      this.checkedOkCount++;
    }

    this.needAuthorization += this.countPendingAuthorization(checkpoint?.serviceJobs || []);
  }

  private countPendingAuthorization(serviceJobs: any[] = []): number {
    return Array.isArray(serviceJobs)
      ? serviceJobs.filter(({ approvalStatus }: any) => {
          const status = approvalStatus?.trim().toLowerCase() || '';
          return status === '' || status === 'notprovided';
        }).length
      : 0;
  }

  navigateToIssues() {
    if (this.isLargeScreen) {
      return;
    }
    else {
      this.appService.setResponseData(this.apiResponse);
      this.appService.setStylesettings(this.siteSettings);
      this.appService.dealerMediaResponse(this.dealerImageDetails);
      void this.router.navigate(['/vvr-jobs-auth'], {
        queryParams: {
          ...this.route.snapshot.queryParams,
          filter: this.criticalCount > 0 ? 'critical' : 'caution'
        }
      });
    }
  }

  navigateToPendingRequests(event: Event) {
    event.stopPropagation();
    if (this.isLargeScreen) {
      return;
    }

    this.appService.setResponseData(this.apiResponse);
    this.appService.setStylesettings(this.siteSettings);
    this.appService.dealerMediaResponse(this.dealerImageDetails);
    void this.router.navigate(['/vvr-jobs-auth'], {
      queryParams: {
        ...this.route.snapshot.queryParams,
        filter: 'pending'
      }
    });
  }

  navigateToCheckedOk() {
    if (this.isLargeScreen) {
      return;
    }
    else {
      this.appService.setResponseData(this.apiResponse);
      this.appService.setStylesettings(this.siteSettings);
      this.appService.dealerMediaResponse(this.dealerImageDetails);
      this.router.navigate(['/vvr-jobs-auth'], {
        queryParams: {
          ...this.route.snapshot.queryParams,
          filter: 'checked'
        }
      });
    }
  }

  downloadPdf() {
    if (this.pdfBase64Data) {
      if (!this.downloadCompleted) {
        this.isDownloading = true;
      }

      this.pdfService.downloadPdf(this.pdfBase64Data, 'Vehicle-Reception-Check-Report.pdf', 'application/pdf')
        .then(() => {
          if (!this.downloadCompleted) {
            setTimeout(() => {
              this.isDownloading = false;
              this.downloadCompleted = true;

              setTimeout(() => {
                this.downloadCompleted = false;
              }, 5000);

            }, 1000);
          }
        })
        .catch(() => {
          this.isDownloading = false;
          alert('Download failed!');
        });
    } else {
      this.isPDFDataAvailable = false;
    }
  }

  getChecklistReport(token: string) {
    this.appService.getPDFReport(token)?.subscribe((data: string) => {
      this.pdfBase64Data = data;
      this.isPDFDataAvailable = true;
    })
  }

  checkScreenSize() {
    this.isLargeScreen = window.innerWidth > 900;
  }

}
